import axios from 'axios'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';
import {CANCELAR_CTE_OS} from '../types';

export default function cancelarCteOs (emisaoCteOsId, empresaId) {

  const url = `${URL}/evento-cte/cte-os/${emisaoCteOsId}/empresa/${empresaId}/cancelar`;
  return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CANCELAR_CTE_OS,
        payload: response

      })
  );
}
